export const DeviceType = {
  TABLET: 0,
  PRINTER: 1,
  POS: 2
};

export const DeviceTypeDropdown = [
  {
    value: DeviceType.TABLET,
    text: "Tablet",
  },
  {
    value: DeviceType.PRINTER,
    text: "Printer",
  },
];

export const IntegrationDeviceDropdown = [
  {
    value: DeviceType.TABLET,
    text: "Tablet",
  },
  {
    value: DeviceType.POS,
    text: "POS",
  },
];
